import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authenticateUserFromStorage } from './sessionSlice';
import { getUserGenericConfig } from './sessionConfig/sessionUserConfigurations';
import { RootState, AppDispatch } from '../../store';
import { Outlet } from 'react-router-dom';
import LoadingModal from '../../components/modal/loadingModal/LoadingModal';

function PersistLogin() {
  const userValidated = useSelector((state: RootState) => state.session.loggedIn);
  const currentUser   = useSelector((state: RootState) => state.session.currentUser);
  const authHeaders   = useSelector((state: RootState) => state.session.authHeaders);
  const dispatch      = useDispatch<AppDispatch>();
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    dispatch(authenticateUserFromStorage()).then(() => setInitializing(false));
  }, []);

  useEffect(() => {
    if (userValidated && currentUser?.nickname && authHeaders) {
      dispatch(getUserGenericConfig({ authHeaders, userNickname: currentUser.nickname }));
    }
  }, [userValidated]);

  if (initializing) {
    return <LoadingModal />;
  }

  return <Outlet />;
}

export default PersistLogin;
